<template>
  <div
    class="body-1 pb-24 lg:pb-0"
    data-qa="orderline-card-content-express-replacement-on-going"
    data-test="orderline-card-content-express-replacement-on-going"
  >
    <p class="mb-24">
      {{
        i18n(translations.paragraph1, {
          date: new Date(
            props.expressReplacedByReplacementOrderline.creationDate,
          ),
        })
      }}
    </p>

    <p class="mb-24">
      {{
        i18n(translations.paragraph2, {
          date: new Date(props.expressReplacementReturnWindow),
        })
      }}
    </p>

    <RevLink target="_blank" :to="expressReplacementFaqArticleLink">
      {{ i18n(translations.faqLinkLabel) }}
    </RevLink>
  </div>
</template>

<script lang="ts" setup>
import { useRuntimeConfig, useZendeskFaqBaseUrl } from '#imports'

import type { DateDate } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { toNuxtLink } from '@backmarket/nuxt-module-navigation/toNuxtLink'
import { RevLink } from '@ds/components/Link'

import type { ExpressReplacedByReplacementOrderline } from '~/api/my-orders/types/OrderlineExpressReplacement.types'
import { isConfigDefined } from '~/scopes/care-commons/utils/isConfigDefined'

import translations from './OrderlineCardExpressReplacementOngoing.translations'

interface OrderlineCardExpressReplacementOngoingProps {
  expressReplacedByReplacementOrderline: ExpressReplacedByReplacementOrderline
  expressReplacementReturnWindow: DateDate
}

const props = defineProps<OrderlineCardExpressReplacementOngoingProps>()

const i18n = useI18n()

const { ZENDESK_EXPRESS_REPLACEMENT_FAQ_ARTICLE } = useRuntimeConfig().public
const { zendeskFaqBaseUrl } = useZendeskFaqBaseUrl()

const expressReplacementFaqArticleLink = toNuxtLink({
  type: 'external',
  href: `${zendeskFaqBaseUrl}/articles/${isConfigDefined(ZENDESK_EXPRESS_REPLACEMENT_FAQ_ARTICLE, 'ZENDESK_EXPRESS_REPLACEMENT_FAQ_ARTICLE')}`,
})
</script>
